import { createApi } from '@reduxjs/toolkit/query/react';
import trelloApi from '@chronos/api-client/trelloApi';
import { fetchBaseQuery } from '@reduxjs/toolkit/query';

export const getTrelloHeaders = ({ getState = () => {} }) => {
  const apiToken = getState()?.app?.trelloToken ?? trelloApi.getTrelloToken();
  const apiKey = getState()?.app?.trelloApiKey ?? trelloApi.getTrelloApiKey();
  let trelloHeaders = {};

  if (apiToken && apiKey) {
    trelloHeaders = {
      authorization: `OAuth oauth_consumer_key="${apiKey}", oauth_token="${apiToken}"`,
    };
  }

  return trelloHeaders;
};

const baseQuery = fetchBaseQuery({
  baseUrl: 'https://api.trello.com/1',
  prepareHeaders: (headers, { getState }) => {
    const trelloHeaders = getTrelloHeaders({ getState });
    Object.entries(trelloHeaders).forEach(([key, value]) => {
      headers.set(key, value);
    });
    return headers;
  },
});

export const trelloBaseApi = createApi({
  reducerPath: 'trelloApi',
  endpoints: () => ({}),
  baseQuery,
});
